const pushServerPublicKey = "BE09zaH66fEAyFFwbVxCaaNiUETYObOtGgFClyFn64CfgWbJBqSFadjq3soynT08lvYPbFaPGoZTzIQYmMKLAT4=";

/**
 * checks if Push notification and service workers are supported by your browser
 */
function isPushNotificationSupported() 
{
  if(typeof navigator != 'undefined')
  {
    return "Notification" in window && "serviceWorker" in navigator && "PushManager" in window;
  }
  else
  {
    return false
  }
}

/**
 * asks user consent to receive push notifications and returns the response of the user, one of granted, default, denied
 */
async function askUserPermission() {
  if (isIOS()) return false;
  if(typeof Notification != 'undefined' )
  {
    return await Notification.requestPermission();
  }
  else{
    return false
  }
}

function registerServiceWorker() 
{
  if(typeof navigator != 'undefined' && navigator?.serviceWorker)
  {
    return navigator.serviceWorker.register("/sw.js");
  }
  else
  {
    return null;
  }
}

/**
 *
 * using the registered service worker creates a push notification subscription and returns it
 *
 */
async function createNotificationSubscription() 
{
  //wait for service worker installation to be ready

      const serviceWorker = await navigator.serviceWorker.ready;
      // subscribe and return the subscription
      return await serviceWorker.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(pushServerPublicKey)
      });
}


function urlBase64ToUint8Array(base64String) 
{
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
      .replace(/-/g, '+')
      .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
  }


  return outputArray;
}

/**
 * returns the subscription if present or nothing
 */
function getUserSubscription() {
  //wait for service worker installation to be ready, and then
  if(typeof navigator != 'undefined' && navigator?.serviceWorker)
  {
  return navigator.serviceWorker.ready
    .then(function(serviceWorker) {
      return serviceWorker.pushManager.getSubscription();
    })
    .then(function(pushSubscription) {
      return pushSubscription;
    });
  }
}

function isIOS() {
  const browserInfo = navigator.userAgent.toLowerCase();

  if (browserInfo.match('iphone') || browserInfo.match('ipad')) {
    return true;
  }
  return false;
}


export {
  isPushNotificationSupported,
  askUserPermission,
  registerServiceWorker,
  createNotificationSubscription,
  getUserSubscription
};
